import { Extension, isNodeSelection, isTextSelection } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { isNil } from "lodash-es";

type HighlightSelectionOptions = {
  className: string;
};

const HighlightSelection = Extension.create<HighlightSelectionOptions>({
  name: "highlightSelection",

  addOptions: () => ({
    className: "outline-default",
  }),

  addProseMirrorPlugins() {
    const { options } = this;

    return [
      new Plugin({
        key: new PluginKey("highlightSelection"),
        props: {
          decorations: ({ doc, selection }) => {
            // Avoid creating decorations for things like GapCursor
            if (!(isTextSelection(selection) || isNodeSelection(selection))) {
              return DecorationSet.empty;
            }

            const { anchor } = selection;
            let decoration: Decoration | undefined = undefined;

            doc.descendants((node, pos) => {
              if (node.type.name === "table") {
                const selectionAnchorInNode = anchor >= pos && anchor <= pos + node.nodeSize - 1;
                if (selectionAnchorInNode) {
                  decoration = Decoration.node(pos, pos + node.nodeSize, {
                    class: options.className,
                  });
                }

                return true;
              }
            });

            return isNil(decoration) ? DecorationSet.empty : DecorationSet.create(doc, [decoration]);
          },
        },
      }),
    ];
  },
});

export default HighlightSelection;
